import React from 'react';

const About: React.FC = () => {
    return (
        <div className="container mt-5">
            <h1 className="mb-3">About Us</h1>
            <p className="lead">
                This is a sample About page using Bootstrap styling in a React + TypeScript project.
            </p>
        </div>
    );
};

export default About;
